import React, { useEffect, useState } from 'react';
import { CardHeader } from '@mui/material';
import { StyledCellLink, Weight } from '../Common/DataGrid/CellComponents';
import { getRangeFilterOperator } from '../Common/DataGrid/FilterComponents';
import { select_commonCellProps, text_commonCellProps } from '../Common/DataGrid/utils';
import {
    DataGrid,
    PageTitleWithToolTip
} from '../Common';
import Routes from '../../routes';
import 'react-super-responsive-table/dist/SuperResponsiveTableStyle.css';
import { fetchFilterValues } from '../../utils';
import { TranslateW } from '../../Utils/Languages/Translate';

const rangeFilterOperator = getRangeFilterOperator({});

const columns = [
    {
        field: 'name',
        headerName: 'System Name',
        ...text_commonCellProps,
        renderCell: ({ row: { name, id } }) => (
            <StyledCellLink
                path={`/Inventory/${id}`}
                text={name}
                from={"Compliance Center"}
                primaryLink={true}
            />
        )
    },
    {
        field: 'region',
        headerName: 'Region',
        ...text_commonCellProps
    },
    {
        field: 'locationName',
        headerName: 'Location',
        ...select_commonCellProps,
        renderCell: ({ row: { locationName, locationId } }) => (
            <StyledCellLink
                path={`/Location/${locationId}`}
                text={locationName}
                from={"Compliance Center"}
                primaryLink={true}
            />
        )
    },
    {
        field: 'type',
        headerName: 'Type',
        ...select_commonCellProps
    },
    {
        field: 'materialType',
        headerName: 'Material Type',
        ...select_commonCellProps
    },
    {
        field: 'gasCapacity',
        headerName: 'Charge Size',
        valueGetter: (value) => value,
        filterOperators: rangeFilterOperator,
        renderCell: ({ row: { gasCapacity } }) => <Weight value={gasCapacity} />
    },
    {
        field: 'currentGasWeight',
        headerName: 'Current Gas Weight',
        valueGetter: (value) => value,
        filterOperators: rangeFilterOperator,
        renderCell: ({ row: { currentGasWeight } }) => <Weight value={currentGasWeight} />
    }
]

const AssetDueForInspection = () => {
    const [filters, setFilters] = useState([]);

    const fetchFilters = async () => {
        const filters = await fetchFilterValues(Routes.Dashboard.AssetsDueForInspectionDropdown());
        setFilters(filters);
    };

    useEffect(() => { fetchFilters() }, []);

    return (
        <div top-five-leak-rate-card>
            <DataGrid
                url={Routes.Dashboard.AssetsDueForInspection(false)}
                exportButtonURL={Routes.Dashboard.AssetsDueForInspection(true)}
                filterOptions={filters}
                columns={columns}
                rowCount="5"
                tableId={'assets-for-inspection-table'}
                exportFileName={TranslateW("AssetsForInsepction")}
                exportButtonAlt={`Export ${TranslateW("AssetsForInsepction")} (.csv)`}
                noResultText="Oops...It is empty here..."
                noResultText2="Create a new asset or change your search criteria."
                headerContent={
                    <CardHeader
                        title={
                            <PageTitleWithToolTip
                                pageTitle={TranslateW("AssetsForInsepction")}
                                toolTipText="Review and schedule leak inspections as needed for assets requiring an inspection."
                            />
                        }
                        sx={{
                            "& .MuiCardHeader-action": { display: "flex" },
                            "& .MuiCardHeader-content": { maxWidth: "100%", textWrap: "nowrap" }
                        }}
                    />
                }
            />
        </div>
    );
}

export default AssetDueForInspection;
